module.exports = __webpack_public_path__ + "static/the-clan-of-the-cave-bear-073332952f1a68c92032f629432e1f82.jpg";